import { Injectable } from '@angular/core';
import { DataCoreService, DlistDto, GetDlist_Request, GetDlist_Response} from '@dabnet-kamu/libs/ui';
import { BehaviorSubject, catchError, finalize, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment as env } from '@dabnet-kamu/libs/ui';
@Injectable()
export class KonuService {
  public birimKod!: number;
  public isReadOnly!: boolean;
  public isBindCheck!: boolean;
  public _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
    public gridControlsList$ = this._gridControlsList.asObservable();
     constructor(private dataCoreService: DataCoreService,private _httpClient:HttpClient) {}


  setParams(birimKod: number, isReadOnly:boolean, isBindCheck:boolean){
    this.birimKod = birimKod;
    this.isReadOnly = isReadOnly;
    this.isBindCheck = isBindCheck;
  }
  

  getData(code: number,control:any,birimKod:number, baseEntity?: string, isSetData?: boolean) {
     let dataSource: any;
     let tableName = "";
    const filterArr = [];
      if (this.isBindCheck && this.isReadOnly){
      tableName = control.showEntity?control.showEntity:control.dlistMetadata.baseEntity;
      dataSource = this.dataCoreService.getOData(tableName);
    } 
    else{
      dataSource = this.dataCoreService.getOData(baseEntity,['CmyKonu','GenBirim','GenKullanici']);
      if (this.birimKod) filterArr.push(['BirimKod', '=', birimKod]);
    }
    dataSource.select(['CmyKonu.Ad','GenBirim.Ad','GenKullanici.Adi','GenKullanici.Soyadi']);
    if (code) filterArr.push(['KonuKod', '=', code]);
    if (filterArr.length > 0) dataSource.filter(filterArr);
    return dataSource;
  }
}
